// frontend/src/pages/renew/RenewalWizard.tsx
import { ApplicationWizard } from '@/pages/apply/ApplicationWizard';
import { renewalsDataSource } from '@/lib/wizardDataSource';

/**
 * Signature Grant renewal wizard (F-027). Reuses the full-fidelity application
 * wizard, switched to the renewals data source. The server pre-fills the draft
 * from the family's data; the wizard hydrates it like any other draft.
 */
export function RenewalWizard() {
  return <ApplicationWizard flow="renewal" dataSource={renewalsDataSource} />;
}

export default RenewalWizard;
